export default "__VITE_ASSET__CClX6ykz__"